class PressScroll {
  constructor() {
    this.initialize()
  }

  initialize() {
    if(document.querySelector('.js-press-grid') == null) return
    this.bindUI()
    this.bindEvents()
  }

  bindUI() {
    this.ui = {}
    this.ui.$pressGrid = document.querySelector('.js-press-grid')
    this.ui.$pressItems = this.ui.$pressGrid.querySelectorAll('.js-press-item-slow')
    this.ui.$containerScroll = document.querySelector('.js-scroll-grid')
    this.latestKnownScrollY = 0
    this.ticking = false
  }

  bindEvents() {
    window.addEventListener('scroll', this.onScroll.bind(this))
  }

  onScroll() {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop
    const top = 1 + (currentScroll / 40)


    for (let i = 0; i < this.ui.$pressItems.length; i++) {
      this.ui.$pressItems[i].style.transform = `translate3d(0, -${top}px, 0)`
    }
  }
}

export default PressScroll
